// sensei-app/common/schemas/collections/classSchedules.js

// Drop-in replacement for the entire file content
import { z } from "zod";

const ClassScheduleSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    studentId: z.string().describe("The student this class is scheduled for."),
    courseId: z.string().describe("The course this class belongs to."),
    topicId: z.string().describe("The unique ID (file path) of the topic to be covered."),
    topicTitle: z.string().optional().nullable().describe("The human-readable title of the topic."),
    scheduledDateTime: z.coerce.date().describe("The date and time the class is scheduled for."),
    status: z.enum(["scheduled", "completed", "cancelled", "missed", "paused"]).default("scheduled"), // Added 'paused'
    
    // --- NEW & MODIFIED FIELDS ---
    attendanceCount: z.number().int().default(0).describe("How many times the student has attended this class."),
    sessionState: z.object({
        chatLog: z.array(z.any()).optional().describe("The full chat history for session replay."),
    }).optional().nullable().describe("Stores the state of a paused session."),
    // --- END NEW & MODIFIED FIELDS ---

    summaryDocumentPageId: z.string().optional().nullable().describe("The _id of the Document page containing the class summary."), 

    scheduledBy: z.string().describe("ID of the entity that scheduled the class (student user ID or coordinator agent contactId)."),
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default ClassScheduleSchema;